var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMinWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 496.983 496.983",
    height: 512,
    viewBox: "0 0 496.983 496.983",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496.983 29.358v30l-30 30v-81.215c0-5.159 5.098-8.804 9.965-7.091 11.671 4.109 20.035 15.23 20.035 28.306z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.983 8.143v81.215l-30-30v-30c0-13.077 8.364-24.198 20.035-28.306 4.867-1.712 9.965 1.932 9.965 7.091z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.983 361.358h-60v105c0 16.57 13.43 30 30 30h30z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.983 230.148 60 96.65c17.48-6.18 30-22.85 30-42.44v-54.21z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.983 90.194 45 191.914c18.31-10.56 30-30.24 30-51.96v-139.954z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.983 90.194v59.164c0 16.57-13.43 30-30 30h-44.866c-54.59 0-102.3 36.84-116.1 89.66l-9.877 37.759 168.843 67.582v-38.45c0-12.88 8.22-24.32 20.42-28.43l41.58-14.02v33.76c0 8.05-6.53 14.58-14.58 14.58-8.07 0-15.02 6.21-15.4 14.27-.41 8.62 6.46 15.73 14.98 15.73 24.85 0 45-20.15 45-45v-236.605z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.983 466.358h-30l30 30h21.215c5.159 0 8.804-5.098 7.091-9.965-4.108-11.671-15.229-20.035-28.306-20.035z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.983 466.358h-62v-92c0-49.706-40.294-90-90-90h-49.817c-13.649 0-25.577 9.213-29.026 22.418l-29.973 114.751c-6.91 26.41-30.76 44.83-58.06 44.83h-103.107c-8.284 0-15 6.716-15 15s6.716 15 15 15h117.087c34.2 0 65.44-19.38 80.63-50.02l27.27-54.98h89.996v75c0 16.569 13.431 30 30 30h107c0-16.569-13.43-29.999-30-29.999z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.983 59.358-30 49.897 30 49.897c2.763-2.174 5.077-4.948 6.708-8.21l16.957-33.915c4.166-8.331 6.334-17.518 6.334-26.833v-30.836z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.983 59.358v30.836c0 9.315 2.169 18.501 6.334 26.833l16.957 33.915c4.111 8.223 12.515 13.417 21.708 13.417 5.546 0 10.798-1.901 15-5.206v-99.795z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinWhite);
export default __webpack_public_path__ + "static/media/logo-min-white.cd08139c41517c79e2a290e061bdb250.svg";
export { ForwardRef as ReactComponent };